module.exports = __webpack_public_path__ + "static/media/feijoa_hawthorn_compote.23dd654d.png";